var render, staticRenderFns
import script from "./SubscriberAvatar.vue?vue&type=script&lang=js&"
export * from "./SubscriberAvatar.vue?vue&type=script&lang=js&"
import style0 from "./SubscriberAvatar.vue?vue&type=style&index=0&id=fe48c89a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe48c89a",
  null
  
)

export default component.exports